import React from 'react';
import { IconProps } from '../types';

export const ECommerceMarketingIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_39636)">
            <path d="M5 19V30H27V19" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path
                d="M30.973 11C30.85 12.1002 30.3257 13.1164 29.5005 13.8544C28.6753 14.5923 27.607 15.0002 26.5 15C25.8278 14.9896 25.1661 14.832 24.5614 14.5383C23.9567 14.2446 23.4237 13.8219 23 13.3C22.5822 13.8286 22.0504 14.256 21.4444 14.5503C20.8384 14.8447 20.1737 14.9984 19.5 15C18.8275 14.9915 18.1651 14.8348 17.5601 14.5409C16.9551 14.2471 16.4224 13.8234 16 13.3C15.5775 13.8234 15.0448 14.2471 14.4399 14.5409C13.8349 14.8348 13.1725 14.9915 12.5 15C11.8262 14.9984 11.1616 14.8447 10.5555 14.5503C9.94951 14.256 9.41777 13.8286 8.99998 13.3C8.57306 13.8183 8.03941 14.2384 7.43542 14.5318C6.83142 14.8252 6.17128 14.9849 5.49998 15C4.39293 15.0002 3.32465 14.5923 2.49944 13.8544C1.67422 13.1164 1.14998 12.1002 1.02698 11L6.99998 2H25L30.973 11Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M13 30V22H19V30" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        </g>
        <defs>
            <clipPath id="clip0_9520_39636">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
